import { PartnerLogoProps } from "@ctypes";
import { resolveLogoSize } from "@utils/logo";

const WIDTH = 472.77;
const HEIGHT = 143.771;

export const GreatPlainsWatermark = ({ className, style, width, height }: PartnerLogoProps) => {
  const size = resolveLogoSize({ width, height, naturalWidth: WIDTH, naturalHeight: HEIGHT });

  return (
    <svg
      width={size.width}
      height={size.height}
      viewBox="0 0 472.77 143.771"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <g id="Group 41545">
      <path id="Vector" d="M140.954 0L212.745 71.8856L140.954 143.771H237.258L295.917 85.0354L309.049 71.8856L295.917 58.7358L237.258 0H140.954ZM203.99 26.2996H225.877L259.146 58.7358H237.258L203.99 26.2996ZM237.258 85.0354H259.146L226.753 117.472H204.865L237.258 85.0354Z" fill="white" fillOpacity="0.09"/>
      <path id="Vector_2" d="M23.6385 0L82.2966 58.7358H13.1325L0.00012207 71.8856L13.1325 85.0354H82.2966L23.6385 143.771H119.943L178.601 85.0354L191.733 71.8856L178.601 58.7358L119.943 0H23.6385ZM86.6741 26.2996H108.561L140.955 58.7358H119.067L86.6741 26.2996ZM119.067 85.0354H140.955L108.561 117.472H86.6741L119.067 85.0354Z" fill="white" fillOpacity="0.04"/>
      <path id="Vector_3" d="M260.024 0L331.815 71.8856L260.024 143.771H356.329L414.987 85.0354H459.637L472.77 71.8856L459.637 58.7358H414.987L356.329 0H260.024ZM323.06 26.2996H344.947L377.341 58.7358H355.453L323.06 26.2996ZM355.453 85.0354H377.341L344.947 117.472H323.06L355.453 85.0354Z" fill="white" fillOpacity="0.11"/>
      </g>
    </svg>
  );
};
